<template>
  <el-row class="ticket_manage_filter">
    <el-input
      v-model="fitter.ticket_num"
      size="mini"
      clearable
      placeholder="发票号"
      @input="handleTicketNumChange"
    >
    </el-input>
    <el-select
      v-model="fitter.company_id"
      filterable
      remote
      reserve-keyword
      placeholder="请输入公司名称筛选公司"
      size="mini"
      clearable
      :remote-method="searchRemoteCompanyMethod"
      :loading="searchLoading"
      @change="handleSearchCompanyChange"
    >
      <el-option
        v-for="searchCompany in searchCompanies"
        :key="searchCompany.id"
        :label="searchCompany.company_name"
        :value="searchCompany.id"
      >
      </el-option>
    </el-select>
    <el-popover placement="bottom-start" v-model="searchVisible">
      <el-form :model="fitter" ref="searchForm" label-width="80px">
        <el-form-item label="发票类型" prop="ticket_type">
          <el-select v-model="fitter.ticket_type" placeholder="请选择" size="mini">
            <el-option label="普通发票" value="普通发票"></el-option>
            <el-option label="专用发票" value="专用发票"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签收状态" prop="sign_status">
          <el-select v-model="fitter.sign_status" placeholder="请选择" size="mini">
            <el-option label="未操作" :value="0"></el-option>
            <el-option label="未查询到" :value="1"></el-option>
            <el-option label="已签收" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作人" prop="operator_id">
          <el-cascader
            v-model="fitter.operator_id"
            placeholder="操作人"
            :options="adminUsers"
            size="mini"
            :props="{ expandTrigger: 'hover' }"
            clearable
            filterable
            :filter-method="filterOptions"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="操作时间" prop="created_at">
          <el-date-picker
            v-model="fitter.created_at"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="开票时间" prop="ticket_at">
          <el-date-picker
            v-model="fitter.ticket_at"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="handelClearSearch('searchForm')" size="mini">重置</el-button>
          <el-button type="primary" @click="submitForm('searchForm')" size="mini">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button slot="reference" size="mini">筛选</el-button>
    </el-popover>
  </el-row>
</template>

<script>
import { filterKeywordOptions } from '../../lib/cascaderUtils.js'
export default {
  name: 'TicketManageFilter',
  props: {
    fitter: {
      type: Object,
      default: () => {
        return {
          ticket_num: '',
          company_id: '',
          ticket_type: '',
          sign_status: '',
          created_at: '',
          ticket_at: '',
          operator_id: ''
        }
      }
    },
    adminUsers: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      searchLoading: false,
      searchCompanies: [],
      searchVisible: false
    }
  },
  methods: {
    handleTicketNumChange (val) {
      console.log(this.fitter)
      this.$emit('search', this.fitter)
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true
        setTimeout(() => {
          this.searchArrItemCompanys(query)
        }, 200);
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query, { loadingClose: true }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies
          this.searchLoading = false
        }
      })
    },
    handleSearchCompanyChange(val) {
      this.fitter.company_id = val
      this.$emit('search', this.fitter)
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    },
    handelClearSearch(formName) {
      this.$refs[formName].resetFields()
      this.searchVisible = false
      this.$emit('search', false)
    },
    submitForm(formName) {
      this.searchVisible = false
      this.$emit('search', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
.ticket_manage_filter >>> .el-input {
  width: auto;
}
.el-form-item {
  margin-bottom: .1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/ticket_manage/TicketManageFilter.vue